function makeDownloadUrl(text){
    var b = new Blob([text], {type: "text/plain"});
    return URL.createObjectURL(b);
}

export default makeDownloadUrl;



// WEBPACK FOOTER //
// ./src/io.js